// extracted by mini-css-extract-plugin
export default {"containerInfo":"Info_containerInfo__7UWiO","headerInfo":"Info_headerInfo__wBJEV","bodyInfo":"Info_bodyInfo__AgELn","link":"Info_link__xhxCR"};